export interface AppPreferences {
  lowStockAlerts: boolean;
  overduePoAlerts: boolean;
  pendingReturnAlerts: boolean;
  readyToShipAlerts: boolean;
  dateFormat: "mdy" | "dmy" | "ymd";
}

type NotifPreferenceKey =
  | "lowStockAlerts"
  | "overduePoAlerts"
  | "pendingReturnAlerts"
  | "readyToShipAlerts";

const KEY = "commerceops.prefs";

const DEFAULTS: AppPreferences = {
  lowStockAlerts: true,
  overduePoAlerts: true,
  pendingReturnAlerts: true,
  readyToShipAlerts: true,
  dateFormat: "dmy",
};

export function getPreferences(): AppPreferences {
  try {
    const stored = JSON.parse(localStorage.getItem(KEY) ?? "");
    return { ...DEFAULTS, ...stored };
  } catch {
    return { ...DEFAULTS };
  }
}

export function savePreferences(prefs: AppPreferences): void {
  localStorage.setItem(KEY, JSON.stringify(prefs));
}

const NOTIF_TYPE_TO_PREF: Record<string, NotifPreferenceKey> = {
  low_stock: "lowStockAlerts",
  po_overdue: "overduePoAlerts",
  return_pending: "pendingReturnAlerts",
  ready_to_ship: "readyToShipAlerts",
};

// Unknown notification types are always shown; only the four operational
// alert types can be toggled off.
export function isNotifTypeEnabled(type: string): boolean {
  const key = NOTIF_TYPE_TO_PREF[type];
  if (!key) return true;
  return getPreferences()[key];
}
